import type { VoidFunctionComponent } from 'react';
import type { ModalProps } from '.';
import ModalStreamBuild from '../../../modals/ModalStreamBuild';

type Props = Omit<ModalProps, 'projectRevision'>;

const StreamBuild: VoidFunctionComponent<Props> = ({ modals }) => {
  const { isOpen, onClose } = modals.streamBuildModal;
  const { buildId } = modals.streamBuildModal.context;

  if (!buildId) {
    return null;
  }

  return (
    <ModalStreamBuild
      buildId={buildId}
      show={isOpen}
      onHide={onClose}
      isProjectLocator={false}
    />
  );
};

export default StreamBuild;
